import { render, staticRenderFns } from "./complaintNewFinish.vue?vue&type=template&id=5ea6734a&scoped=true&"
import script from "./complaintNewFinish.vue?vue&type=script&lang=js&"
export * from "./complaintNewFinish.vue?vue&type=script&lang=js&"
import style0 from "./complaintNewFinish.vue?vue&type=style&index=0&id=5ea6734a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6734a",
  null
  
)

export default component.exports